import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popover  } from 'react-bootstrap';
import ZoneForm from "./ZoneForm";
import ZonesList from "./ZonesList";

export default function ZonesPopover (props) {
    const { zones, filteredZones, mode, setMode, searchText, setSearchText, getZones, getZoom, map, mapState, behavior, platform, editedZone, setEditedZone, highlightedZoneId, highlightZoneOnMap } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'zonesPage' });

    const zoomToZone = (position, radius) => {
        const zoom = getZoom(radius);
        if (map) {
            map.getViewModel().setLookAtData({
                position: { lat: position.lat, lng: position.lng },
                zoom: zoom
            }, true);
        }
    }

    return (
        <Popover className="zones-popover">
            <Popover.Body>
                {['CREATE', 'EDIT'].includes(mode) ? (
                    <ZoneForm
                        mode={mode}
                        setMode={setMode}
                        editedZone={editedZone}
                        getZones={getZones}
                        hasZones={zones.length}
                        map={map}
                        mapState={mapState}
                        behavior={behavior}
                        platform={platform}
                        zoneNames={zones.map(zone => zone.zone_name.toLowerCase())}
                    />
                ) : ''}
                {mode === 'LIST' ? (
                    <ZonesList
                        zones={zones}
                        setMode={setMode}
                        setEditedZone={setEditedZone}
                        searchText={searchText}
                        setSearchText={setSearchText}
                        filteredZones={filteredZones}
                        getZones={getZones}
                        zoomToZone={zoomToZone}
                        highlightedZoneId={highlightedZoneId}
                        highlightZoneOnMap={highlightZoneOnMap}
                    />
                ) : ''}
            </Popover.Body>
        </Popover>
    )
}
